import type { VariablesOf } from '@graphql-typed-document-node/core';
import { graphql } from '@/gql';

export const CreateGroupMutation = graphql(`
    mutation CreateGroup($input: CreateGroupInput!) {
        createGroup(input: $input) {
            __typename
            ... on CreateGroupSuccessfulResponse {
                result {
                    ...GroupItemData
                }
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);

const _GroupItemData = graphql(`
    fragment GroupItemData on Group {
        id
        name
        description
        companyId
    }
`);

export type CreateGroupMutationVariables = VariablesOf<typeof CreateGroupMutation>;
